import { useContext, Component } from 'react';
import { Container } from 'reactstrap';
import Alert from 'react-bootstrap/Alert';
import { TenantContext } from '../../../context/TenantContext';
import { SubscriptionEntries } from './SubscriptionEntries';

class LicenseOverviewInternal extends Component {
    refreshSubscriptionsTimer = 0;
    refreshSubscriptionsTimeoutTimer = 0;

    state = {
        isChangeQuantityModalOpen: false,
        isConfirmChangeQuantityModalOpen: false,
    }

    async componentDidMount() {
        await this.refreshSubscriptions();
        this.refreshSubscriptionsTimerStart();
    }

    componentWillUnmount() {
        this.refreshSubscriptionsTimerStop();
    }

    refreshSubscriptionsTimerStart = () => {
        console.log("[refreshSubscriptionsTimerStart]");

        this.refreshSubscriptionsTimer = setInterval(this.refreshSubscriptions, 5000); 
        this.refreshSubscriptionsTimeoutTimer = setInterval(this.refreshSubscriptionsTimerStop, 2* 60 * 60 * 1000); 
    }

    refreshSubscriptionsTimerStop = () => {
        console.log("[refreshSubscriptionsTimerStop]");

        clearTimeout(this.refreshSubscriptionsTimer);
        clearTimeout(this.refreshSubscriptionsTimeoutTimer);
    }
    
    refreshSubscriptions = () => {
        this.props.tenantContext.refreshSubscriptions();
    }

    getSubscriptionsRendered = () => {
        let numberOfSubscriptionTypes = 0;
        let hasOwnerSubscriptions = false;
        let hasManualSubscriptions = false;

        if (this.props.tenantContext.ownerSubscriptions.length > 0) {
            numberOfSubscriptionTypes++;
            hasOwnerSubscriptions = true;
        }

        if (this.props.tenantContext.manualSubscriptions.length > 0) {
            numberOfSubscriptionTypes++;
            hasManualSubscriptions = true;
        }

        // Only show type titles when there is more than 1 subscription type.
        const showTypeTitles = numberOfSubscriptionTypes > 1;

        const ownerSubscriptionsRendered = hasOwnerSubscriptions ?
            <>
                {showTypeTitles ? <div>
                    <h4>Owner</h4>
                </div>: null}
                <div>
                    <SubscriptionEntries subscriptions={this.props.tenantContext.ownerSubscriptions} />
                </div>
            </> :
            null;

        const manualSubscriptionsRendered = hasManualSubscriptions ?
            <>
                {showTypeTitles ? <div>
                    <h4>Fixed</h4>
                </div>: null}
                <div>
                    <SubscriptionEntries subscriptions={this.props.tenantContext.manualSubscriptions} />
                </div>
            </> :
            null;

        return <>
            {ownerSubscriptionsRendered}
            {manualSubscriptionsRendered}
        </>;
    }

    // ------------------------------
    // Rendering starts here...
    // ------------------------------
    render() {
        const headerRendered = <h1>License overview</h1>

        const subscriptionsRendered = this.props.tenantContext.manualSubscriptions.length <= 0 && 
            this.props.tenantContext.ownerSubscriptions.length <= 0 ? 
            <div>
                <Alert variant='warning' style={{ opacity: 1 }}>
                    No subscriptions found for this tenant.<br/>
                    Please use the 'Activate' link in the e-mail you received from Microsoft to add the subscription.
                </Alert>
            </div> : 
            this.getSubscriptionsRendered();

        return (
            <Container fluid>
                {headerRendered}
                {this.props.tenantContext.showWarningWhenDisabled()}
                {subscriptionsRendered}
                <br/>
                <br/>          
            </Container>
        );
    }
}

export const LicenseOverview = (props) => {
    const tenantContext = useContext(TenantContext);
  
    return (
        <LicenseOverviewInternal tenantContext={tenantContext} {...props}/>
    )
}